import { Heading, Text } from "@primer/react";
import "./Section.css";

export function SectionStack({ children }) {
  return <div className="section-stack">{children}</div>;
}

export function Section({ action = null, children, description = null, footer = null, heading, tone = "normal" }) {
  return (
    <section className={`${tone} section`}>
      <div className="section-layout">
        <header>
          <div>
            <Heading as="h2" className="section-heading text-section-heading">{heading}</Heading>
            {description ? <Text className="section-description text-body muted-text">{description}</Text> : null}
          </div>
          {action}
        </header>
        <div className="body">{children}</div>
        {footer ? <Text as="footer" className="section-footer text-caption muted-text">{footer}</Text> : null}
      </div>
    </section>
  );
}
